<div class="darts-scoreboard-header" *ngIf="sitecoreEventDetailsVM$ | async as sitecoreEventDetailsVM">
    <div class="column" *ngIf="sets && score.matchType === matchType.SetsAndLegs" [class.divider]="hasExtended">
        <div class="cell sets">{{ sitecoreEventDetailsVM.sets }}</div>
    </div>
    <div class="column" *ngIf="legs" [class.current-set]="hasExtended && legs && score.matchType === matchType.SetsAndLegs">
        <div class="cell legs">{{ sitecoreEventDetailsVM.legs }}</div>
    </div>
</div>
